import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/distributor/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/distributor/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updatePasswordById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/update-password`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const loginAsAdminUser = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/login`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const validateLoginAsAdminUser = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/validate-login`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchableListData = async () => {
  const options = prepareRequestOptions(
    '/admin/content/distributor/search-list',
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewCredential = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/distributor/create-credential',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const addVideosById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/add-video`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const removeVideosById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/distributor/${id}/remove-video`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
